<script setup lang="ts">
// Global toast UI for src/store/toast.ts — mounted once in App.vue (DESIGN.md section 9.4).
// Top of screen, stacked, auto-dismissing (~4s, handled by the store). Success toasts carry the
// resolved player's avatar + name; error toasts are text-only. Purely presentational — no logic
// beyond rendering the queue and letting a tap dismiss early.
import Avatar from './Avatar.vue'
import { toastStore, dismissToast } from '../store/toast'
</script>

<template>
  <div class="fixed top-3 inset-x-0 z-[95] flex flex-col items-center gap-2 pointer-events-none px-3">
    <TransitionGroup name="toast">
      <div
        v-for="t in toastStore.items"
        :key="t.id"
        class="pointer-events-auto flex items-center gap-3 rounded-2xl border px-4 py-2.5 shadow-2xl max-w-[90vw]"
        :class="t.kind === 'success' ? 'bg-neutral-900 border-emerald-600' : 'bg-neutral-900 border-red-600'"
        @click="dismissToast(t.id)"
      >
        <Avatar v-if="t.kind === 'success' && t.player" :player="t.player" :size="36" />
        <span
          v-else
          class="shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold"
          :class="t.kind === 'success' ? 'bg-emerald-700' : 'bg-red-700'"
        >
          {{ t.kind === 'success' ? '✓' : '!' }}
        </span>
        <span class="font-semibold text-sm leading-tight">{{ t.message }}</span>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
